import ApplicationAdapter from './application';

export default class ReportTrackingAdapter extends ApplicationAdapter {
  namespace = 'api/v2';
}
